/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconInnerShadowBottomRight = createReactComponent("outline", "inner-shadow-bottom-right", "IconInnerShadowBottomRight", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M18 12a6 6 0 0 1 -6 6", "key": "svg-1" }]]);

export { IconInnerShadowBottomRight as default };
//# sourceMappingURL=IconInnerShadowBottomRight.mjs.map
